<template>
  <ag-grid-vue
    :class="{ 'ag-theme-balham-dark' : isDark, 'ag-theme-balham' : !isDark }"
    :style="styleHeight"
    :columnDefs="columnDefs.value"
    :rowData="rowData.value"
    :defaultColDef="defaultColDef"
    :getRowId="getRowId"
    :context="context"
    rowSelection="single"
    :suppressRowClickSelection="isExport"
    animateRows="true"
    @grid-ready="onGridReady"
    @first-data-rendered="onFirstDataRendered"
    @selection-changed="onSelectionChanged"
  >
  </ag-grid-vue>
 
 </template>
 
 <script setup>
 
 import { useConnectionStore } from '@/stores/connectionStore';
  
 import { reactive, onBeforeMount, onMounted, ref } from "vue";
 import { watch } from 'vue'
 import { computed } from "@vue/reactivity"

 import { AgGridVue } from "ag-grid-vue3";  // the AG Grid Vue Component
 
 import CheckboxAgGrid from '@/components/CheckboxAgGrid.vue'
import { t } from '@/composables/translateText.js'

 const gridApi = ref(null); // Optional - for accessing Grid's API
 const getRowId = ref(null)
 const emit = defineEmits(['selected-click','field-value-changed'])
 
const props = defineProps({
  customCatList : {
      type : Array,
      default : []
  },
  customCatListTrigger : {
      type : Number,
      default : 0
  },
  styleHeight : {
    type : String,
    default :  "style= 'height: 300px'" 
  }
   
 })
 
 const connectionStore = useConnectionStore()
 const isDark = ref(connectionStore.getDarkmode != "light")
 
 var selectedRepertoireRow = null

 const parentData = ref(null)

 const context = ref({})
 
 onBeforeMount(() => {
  context.value = {
    // define function or reactive data you want to access from child
    // below data or function can be accessed by child
    parentData, 
    parentFunction,
  }
  getRowId.value = (params) => params.data.id
})

const parentFunction = (e,fieldName,repertoireId,checkboxState) => {
    //console.log("parent function called", fieldName,repertoireId,checkboxState)
    for (var i=0; i < rowData.value.length; i++) {
      const oneRow = rowData.value[i]
      if (oneRow.id == repertoireId) {
        rowData.value[i][fieldName] = (checkboxState) ? 1 : 0
        break
      }
    }
    emit('field-value-changed',repertoireId,fieldName,(checkboxState) ? 1 : 0)
}


  // Obtain API from grid's onGridReady event
  const onGridReady = (params) => {
    //console.log("**** GRID READY")
    gridApi.value = params.api;
    setColumnDefinitions()
  };
 
 const rowData = reactive({}); // Set rowData to Array of Objects, one Object per Row
 
  // Each Column Definition results in one Column.
  const columnDefs = ref({});
 
  // DefaultColDef sets props common to all Columns
  const defaultColDef = {
    editable: true,
    sortable: true,
    filter: false,
    flex: 1,
    resizable: true,
    initialWidth: 200,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    wrapText: true,     // <-- HERE
    autoHeight: true,   // <-- & HERE 
  };
 
  const styleHeight = computed({ get() { return props.styleHeight }})
  const customCatList = computed({ get() { return props.customCatList }})
  const customCatListTrigger = computed({ get() { return props.customCatListTrigger }})
  const isExport = computed({ get() { return props.isExport }})
 
  watch(customCatListTrigger, (newVal,oldVal) => {
    //console.log("repertoiter list trigger")
    rowData.value = customCatList

    if (gridApi.value != null)
      gridApi.value.refreshCells() 
  })
 
  watch(isExport, (newVal,oldVal) => {
    //console.log("isExport list trigger")
    setColumnDefinitions()
    //gridApi.value.refreshCells() 
  })

  function setColumnDefinitions() {

   const fieldsForManager = [
        { field: "name" , headerName : t("Name"), width: 100,
            cellEditor: NameEditor,
        },
        { field: "categories" , headerName : t("Categories"), width: 200,
            cellEditor: NameEditor,
        } 
   ]

   //console.log("****** FIELDS  ",isExport.value)
   columnDefs.value = { value: fieldsForManager }
  }

  function onSelectionChanged() {
    if (isExport.value)
      return
    //console.log(" ROW selected")
    const selectedRows = gridApi.value.getSelectedRows();
    if (selectedRows.length > 0) {
      selectedRepertoireRow = selectedRows[0]
      //console.log("selected info ",selectedRows[0])
      emit("selected-click",selectedRows[0].id)
    }
  }

  function onFirstDataRendered(params) {
    //console.log("on First Data Rendered")

    // export doesn't select rows
    if (isExport.value)
      return

    params.api.forEachNode((node) => {
      if (node.data && node.data.selected) {
        node.setSelected(true)
        return
      }
    });
  }

  // check that the combination of name, min, max and percentage are unique
  function checkUniqueRepertoireEntry(repertoireId,name) {
    for (var i=0; i < rowData.value.length; i++) {
      const oneRow = rowData.value[i]
      // skip if on the same record or one of the fields is different
      if (oneRow.id == repertoireId)
        continue
      //console.log("ONE ROW",oneRow)
      if (oneRow.name != name) {
        continue
      }
      if (oneRow.minrating != min) {
        continue
      }
      if (oneRow.maxrating != max) {
        continue
      }
      window.alert("There is already a repertoire with that name, minimum/maximum rating and percentage")
      return (false)
    }
    return (true)
  }

  // backspace starts the editor on Windows
  const KEY_BACKSPACE = 'Backspace';

  class NumericRangeEditor {
    
    eInput;
    cancelBeforeStart;

    // gets called once before the renderer is used
    init(params) {
      //console.log("In init",params)
      this.fieldName = params.rangeField
      this.repertoireId = params.data.id
      switch (params.rangeField) {
        case "minrating" :
          this.originalValue = params.data.minrating
          this.minimumValue = 800
          this.maximumValue = parseInt(params.data.maxrating) - 50
          this.decimalOkay = false
          break
        case "maxrating" :
          this.originalValue = params.data.maxrating
          this.minimumValue = parseInt(params.data.minrating) + 50
          this.maximumValue = 2550
          this.decimalOkay = false
          break
      }
      // create the cell
      this.eInput = document.createElement('input');
      this.eInput.classList.add('numeric-input');

      if (params.eventKey === KEY_BACKSPACE) {
        this.eInput.value = '';
      } else if (this.isCharNumeric(params.eventKey)) {
        this.eInput.value = params.eventKey;
      } else {
        if (params.value !== undefined && params.value !== null) {
          if (this.decimalOkay) {
            this.eInput.value = params.value.split('%')[0]
          }
          else
            this.eInput.value = params.value;
        }
      }

      this.eInput.addEventListener('keydown', (event) => {
        if (!event.key || event.key.length !== 1) {
          return;
        }
        if (!this.isNumericKey(event)) {
          this.eInput.focus();
          if (event.preventDefault) event.preventDefault();
        } else if (this.isNavigationKey(event) || this.isBackspace(event)) {
          event.stopPropagation();
        }
      });

      // only start edit if key pressed is a number, not a letter
      var startCharacters = "1234567890"
      if (this.decimalOkay)
        startCharacters += "."
      const isNotANumber =
        params.eventKey &&
        params.eventKey.length === 1 &&
        startCharacters.indexOf(params.eventKey) < 0;
      this.cancelBeforeStart = !!isNotANumber;
    }

    isBackspace(event) {
      return event.key === KEY_BACKSPACE;
    }

    isNavigationKey(event) {
      return event.key === 'ArrowLeft' || event.key === 'ArrowRight';
    }

    // gets called once when grid ready to insert the element
    getGui() {
      return this.eInput;
    }

    // focus and select can be done after the gui is attached
    afterGuiAttached() {
      this.eInput.focus();
    }

    // returns the new value after editing
    isCancelBeforeStart() {
      //console.log("is cancel before start",this.cancelBeforeStart)
      return this.cancelBeforeStart;
    }

    isCancelAfterEnd() {
      //console.log("IN isCancel")
      const value = this.eInput.value;
      if (value == '' || value == null)
        return (true)
      return false;
    }

    // returns the new value after editing
    getValue() {
      //console.log("IN getvalue")

      const value = this.eInput.value;

      if (value == '' || value == null)
        return (null)


     
        //console.log("range",this.minimumValue,this.maximumValue)
        var num = parseInt(value)
        num = Math.floor(num / 50) * 50
        if (num <= this.minimumValue)
          num = this.minimumValue
        else
        if (num > this.maximumValue)
          num = this.maximumValue
      
      var isUnique = true
     
      if (!isUnique)
        return (this.originalValue)
      if (num != this.originalValue)
        emit('field-value-changed',this.repertoireId,this.fieldName,num)
      return (num)
    }

    // any cleanup we need to be done here
    destroy() {
      // but this example is simple, no cleanup, we could  even leave this method out as it's optional
    }

    // if true, then this editor will appear in a popup
    isPopup() {
      // and we could leave this method out also, false is the default
      return false;
    }

    isCharNumeric(charStr) {
      if (this.decimalOkay) {
        return (charStr && !!/[.0-9]/.test(charStr))
      }
      else {
        return (charStr && !!/[0-9]/.test(charStr))
      }
    
    }

    isNumericKey(event) {
      const charStr = event.key;
      return this.isCharNumeric(charStr);
    }
  }

  // edits the Name field. Trapping duplicates and adding a (#) suffix
  class NameEditor {
    
    eInput;
    cancelBeforeStart;

    // gets called once before the renderer is used
    init(params) {
      //console.log("In init for Name",params)
      this.repertoireId = params.data.id
      this.originalValue = params.data.name
      this.fieldName = "name"
      // create the cell
      this.eInput = document.createElement('input');
      this.eInput.classList.add('name-input');

      if (params.eventKey === KEY_BACKSPACE) {
        this.eInput.value = '';
      } else if (this.isCharPrintable(params.eventKey)) {
        this.eInput.value = params.eventKey;
      } else {
        if (params.value !== undefined && params.value !== null) {
          this.eInput.value = params.value;
        }
      }

      this.eInput.addEventListener('keydown', (event) => {
        if (!event.key || event.key.length !== 1) {
          return;
        }
        if (!this.isPrintableKey(event)) {
          this.eInput.focus();
          if (event.preventDefault) event.preventDefault();
        } else if (this.isNavigationKey(event) || this.isBackspace(event)) {
          event.stopPropagation();
        }
      });

      this.cancelBeforeStart = false
    }

    isBackspace(event) {
      return event.key === KEY_BACKSPACE;
    }

    isNavigationKey(event) {
      return event.key === 'ArrowLeft' || event.key === 'ArrowRight';
    }

    // gets called once when grid ready to insert the element
    getGui() {
      return this.eInput;
    }

    // focus and select can be done after the gui is attached
    afterGuiAttached() {
      this.eInput.focus();
    }

    // returns the new value after editing
    isCancelBeforeStart() {
      return this.cancelBeforeStart;
    }

    isCancelAfterEnd() {
      const value = this.eInput.value;
      if (value == '' || value == null)
        return (true)
      return false;
    }

    // returns the new value after editing
    getValue() {
      var value = this.eInput.value;

      if (value == '' || value == null)
        return (null)

      const isUnique = checkUniqueRepertoireEntry(this.repertoireId)
      if (!isUnique)
        return (this.originalValue)

      if (value != this.originalValue)
        emit('field-value-changed',this.repertoireId,this.fieldName,value)
      return (value)
    }

    // any cleanup we need to be done here
    destroy() {
      // but this example is simple, no cleanup, we could  even leave this method out as it's optional
    }

    // if true, then this editor will appear in a popup
    isPopup() {
      // and we could leave this method out also, false is the default
      return false;
    }

    isCharPrintable(charStr) {
      return charStr && !!/[ -~]/.test(charStr);
    }

    isPrintableKey(event) {
      const charStr = event.key;
      return this.isCharPrintable(charStr);
    }
  }

  // edits the Color field. use the single Character Ww/Bb
  class ColorEditor {
    
    eInput;
    cancelBeforeStart;

    // gets called once before the renderer is used
    init(params) {
      //console.log("In init for Name",params)
      this.repertoireId = params.data.id
      // create the cell
      this.eInput = document.createElement('input');
      this.eInput.classList.add('color-input');

      if (params.eventKey === KEY_BACKSPACE) {
        this.eInput.value = '';
      } else if (this.isCharColor(params.eventKey)) {
        this.eInput.value = params.eventKey;
      } else {
        if (params.value !== undefined && params.value !== null) {
          this.eInput.value = params.value.substring(0,1);
        }
      }

      this.eInput.addEventListener('keydown', (event) => {
        if (!event.key || event.key.length !== 1) {
          return;
        }
        if (!this.isColorKey(event)) {
          this.eInput.focus();
          if (event.preventDefault) event.preventDefault();
        } else if (this.isNavigationKey(event) || this.isBackspace(event)) {
          event.stopPropagation();
        }
      });

    
      this.cancelBeforeStart = false;
    }

    isBackspace(event) {
      return event.key === KEY_BACKSPACE;
    }

    isNavigationKey(event) {
      return event.key === 'ArrowLeft' || event.key === 'ArrowRight';
    }

    // gets called once when grid ready to insert the element
    getGui() {
      return this.eInput;
    }

    // focus and select can be done after the gui is attached
    afterGuiAttached() {
      this.eInput.focus();
    }

    // returns the new value after editing
    isCancelBeforeStart() {
      return this.cancelBeforeStart;
    }

    isCancelAfterEnd() {
      const value = this.getValue();
      return value == null;
    }

    // returns the new value after editing
    getValue() {
      var value = this.eInput.value;

      if (value == '' || value == null)
        return (null)

      const firstChar = value.substring(0,1).toLowerCase()
      if (firstChar == "w")
        return ("White")
      else
      if (firstChar == "b")
        return ("Black")
      else
        return (null)
    }

    // any cleanup we need to be done here
    destroy() {
      // but this example is simple, no cleanup, we could  even leave this method out as it's optional
    }

    // if true, then this editor will appear in a popup
    isPopup() {
      // and we could leave this method out also, false is the default
      return false;
    }

    isCharColor(charStr) {
      return charStr && !!/[wWbB]/.test(charStr);
    }

    isColorKey(event) {
      const charStr = event.key;
      return this.isCharColor(charStr);
    }
  }

 </script>
 
 <style scoped>
 
 </style>
